/**
 * Station → EVSE → connector, as the panel names it. docs/ocpp-201-spec.md D2.
 *
 * An EVSE is a bay a car charges at; a connector is one gun on it. Every 1.6
 * station reports one gun per EVSE, numbered so that its old connector N is
 * EVSE N — which is why a single-gun EVSE is labelled by its EVSE alone: it
 * reads as the same number an operator already knows.
 */

export interface GunAddress {
  readonly evseId: number;
  readonly connectorId: number;
}

/** EVSE 0, connector 0: the station itself, not a bay. */
const STATION_EVSE = 0;

export function connectorLabel(gun: GunAddress, all: readonly GunAddress[]): string {
  if (gun.evseId === STATION_EVSE) return "Station";

  const gunsOnEvse = all.filter((other) => other.evseId === gun.evseId).length;
  return gunsOnEvse > 1 ? `EVSE ${gun.evseId} · gun ${gun.connectorId}` : `EVSE ${gun.evseId}`;
}

/** The bays a driver can be sold, once each however many guns they have. */
export function bayIds(guns: readonly GunAddress[]): number[] {
  const ids = new Set(guns.map((gun) => gun.evseId).filter((id) => id !== STATION_EVSE));
  return [...ids].sort((a, b) => a - b);
}
